/**
 * PURPOSE:
 * Renderizar una categoría pública de Karate como card seleccionable.
 *
 * RESPONSIBILITIES:
 * - Mostrar código, descripción, modalidad, participantes y combates con UI compacta.
 * - Mantener una UI responsive usando Tailwind.
 *
 * COLLABORATORS:
 * - KarateCategoryList.jsx
 * - karateBracketUtils.js
 *
 * ROUTE:
 * src/components/Software/Karate/Categorias/components/KarateCategoryCard.jsx
 */

import React from "react";
import { getCategorySubtitle, getCategoryTitle } from "../utils/karateBracketUtils.js";

export default function KarateCategoryCard({ category, onSelect }) {
  return (
    <button
      type="button"
      onClick={() => onSelect?.(category)}
      className="group flex h-full w-full flex-col justify-between rounded-2xl border border-slate-200 bg-white p-3.5 text-left shadow-sm transition duration-200 hover:-translate-y-0.5 hover:border-blue-200 hover:bg-blue-50/30 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
    >
      <div className="min-w-0">
        <div className="mb-2 flex items-center justify-between gap-2">
          <span className="inline-flex max-w-[45%] shrink-0 items-center justify-center rounded-full bg-blue-50 px-2.5 py-1 text-[11px] font-black uppercase tracking-wide text-blue-700 ring-1 ring-blue-100">
            {category?.code || `CAT-${category?.id ?? ""}`}
          </span>

          {category?.tatami?.name && (
            <span className="truncate rounded-full bg-slate-50 px-2.5 py-1 text-[11px] font-bold text-slate-500 ring-1 ring-slate-200">
              {category.tatami.name}
            </span>
          )}
        </div>

        <h3 className="line-clamp-2 text-sm font-black leading-snug text-slate-900 sm:text-base" title={getCategoryTitle(category)}>
          {getCategoryTitle(category)}
        </h3>

        <p className="mt-1.5 line-clamp-1 text-xs font-semibold text-slate-500" title={getCategorySubtitle(category) || "Karate"}>
          {getCategorySubtitle(category) || "Karate"}
        </p>
      </div>

      <div className="mt-3 flex items-center justify-between gap-2 border-t border-slate-100 pt-3">
        <div className="flex min-w-0 items-center gap-2 text-[11px] font-bold text-slate-500">
          <span className="rounded-lg bg-slate-50 px-2 py-1 ring-1 ring-slate-100">
            <b className="text-slate-800">{category?.competitorsCount ?? 0}</b> participantes
          </span>
          {/* <span className="rounded-lg bg-slate-50 px-2 py-1 ring-1 ring-slate-100">
            <b className="text-slate-800">{category?.matchesCount ?? 0}</b> comb.
          </span> */}
        </div>

        <span className="shrink-0 text-xs font-black text-blue-700 transition-transform duration-200 group-hover:translate-x-0.5">
          Ver →
        </span>
      </div>
    </button>
  );
}
